export default __webpack_public_path__ + "static/media/hero_main_mx.1e02bcda.png";